import { Card, Row, Col, Form } from "react-bootstrap";
import {
  RiErrorWarningLine,
  RiTimeLine,
  RiInformationLine,
  RiInformationFill
} from "react-icons/ri";

const types = [
  {
    title: "Critical Alerts",
    icon: <RiErrorWarningLine color="white"/>,
    color: "red",
    desc: "Important events that require immediate attention.",
    items: ["Driver Entered Lot", "Driver Left Lot", "Payment Failed"]
  },
  {
    title: "Operational Alerts",
    icon: <RiTimeLine />,
    color: "orange",
    desc: "Important operational updates about your yard.",
    items: ["Booking Expiring Soon", "Spot Almost Full", "Reservation Started", "Reservation Ended"]
  },
  {
    title: "Info Alerts",
    icon: <RiInformationLine />,
    color: "blue",
    desc: "General information and system updates.",
    items: ["New Booking Created", "Payment Received", "System Notifications"]
  }
];

export default function AlertTypes() {
  return (
    <Card className="ap-card alert-types-card">

      {/* HEADER */}
      <div className="section-header">
        <div className="step mb-0">2</div>
        <div>
          <h6>Alert Types</h6>
          {/* <p>Select which alerts you want to receive.</p> */}
        </div>

        {/* <span className="select-all">Select All</span> */}
      </div>

      <Row className="g-3 mt-2">
        {types.map((t, i) => (
          <Col lg={4} md={6} key={i}>
            <div className="alert-box">

              {/* TITLE */}
              <div className="alert-title">
                <div className={`icon px-2 ${t.color}`}>
                  {t.icon}
                </div>
                <div>
                  <h6>{t.title}</h6>
                  <p>{t.desc}</p>
                </div>
              </div>

              {/* LIST */}
              <div className="alert-list">
                {t.items.map((item, idx) => (
                  <div className="alert-item" key={idx}>

                    {/* <Form.Check type="checkbox" defaultChecked /> */}

                    <span>{item}</span>

                    <RiInformationFill className="info-icon" />

                  </div>
                ))}
              </div>

            </div>
          </Col>
        ))}
      </Row>

    </Card>
  );
}